/**
 * Centralized localStorage key constants.
 *
 * Every string key used with localStorage across the app is defined here
 * so that typos are caught at compile time and renames are a single-line change.
 */

// ── Authentication / tokens ─────────────────────────────────────────────────
export const ACCESS_TOKEN_KEY = 'five_ai_access_token';
export const REFRESH_TOKEN_KEY = 'five_ai_refresh_token';

// ── User info ───────────────────────────────────────────────────────────────
export const LOCAL_USER_INFO_KEY = 'five_ai_local_user_info';

// ── Device ──────────────────────────────────────────────────────────────────
export const DEVICE_ID_KEY = 'five_ai_device_id';

// ── Theme ───────────────────────────────────────────────────────────────────
export const THEME_KEY = 'theme';

// ── Cookie consent ──────────────────────────────────────────────────────────
export const COOKIE_CONSENT_KEY = 'five_ai_cookie_consent';

// ── Onboarding flow ─────────────────────────────────────────────────────────
export const ONBOARDING_SESSION_ID_KEY = 'five_ai_onboarding_session_id';
export const ONBOARDING_SESSION_EMAIL_KEY = 'five_ai_onboarding_session_email';
export const ONBOARDING_ANSWERS_KEY = 'five_ai_onboarding_answers';
export const ONBOARDING_QUOTES_KEY = 'five_ai_onboarding_quotes';
export const ONBOARDING_STEP_KEY = 'five_ai_onboarding_current_index';
export const ONBOARDING_COMPLETE_REQUEST_KEY = 'five_ai_onboarding_complete_request';
export const ONBOARDING_AUTH_PROVIDER_KEY = 'five_ai_onboarding_auth_provider';
export const ONBOARDING_RETURNED_FROM_REGISTRATION_KEY = 'five_ai_onboarding_returned_from_registration';
export const ONBOARDING_PLAN_CODE_KEY = 'five_ai_onboarding_plan_code';
export const ONBOARDING_SELECTED_PLAN_DATA_KEY = 'five_ai_onboarding_selected_plan_data';

// ── Login redirect ──────────────────────────────────────────────────────────
export const LOGIN_NEXT_DEST_KEY = 'five_ai_login_next_dest';

// ── Learning path ───────────────────────────────────────────────────────────
/** Prefix — append the plan ID, e.g. `five_ai_learning_path_started_<planId>` */
export const LEARNING_PATH_STARTED_PREFIX = 'five_ai_learning_path_started_';
/** Prefix — append the plan ID, e.g. `five_ai_learning_path_day_unlocked_<planId>` */
export const LEARNING_PATH_DAY_UNLOCKED_PREFIX = 'five_ai_learning_path_day_unlocked_';

// ── Coach ───────────────────────────────────────────────────────────────────
export const COACH_SESSION_KEY = 'five_coach_session';

// ── Admin ───────────────────────────────────────────────────────────────────
export const ADMIN_TOKEN_KEY = 'admin_access_token';
export const ADMIN_USER_KEY = 'admin_user';

// ── Mobile app banner ───────────────────────────────────────────────────────
export const MOBILE_BANNER_DISMISSED_KEY = 'fiveai_mobile_banner_dismissed';
